import React from 'react';
import Header from "../../components/layout/Header";
import Banner from "../../components/home/Banner";
import Footer from "../../components/layout/Footer";

const Sports = () => {
    const banners = [
        "/images/banners/sports_hero.png",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/d34fc9b3a0429712.jpg?q=20",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/3b12ea642f89f924.jpg?q=20",
    ];

    const subCategories = [
        { name: "Badminton", img: "/images/categories/sports/badminton.png" },
        { name: "Treadmills", img: "/images/categories/sports/treadmill.png" },
        { name: "Cycles", img: "/images/categories/sports/cycle.png" },
        { name: "Ball sports", img: "https://rukminim2.flixcart.com/image/128/128/xif0q/sport-ball/s/c/n/-original-imahf4r9f9gzshge.jpeg?q=70" },
        { name: "Kids' favorites", img: "https://rukminim2.flixcart.com/image/128/128/xif0q/remote-control-toy/1/b/g/-original-imahf4r9f9gzshge.jpeg?q=70" },
        { name: "Yoga", img: "/images/categories/sports/yoga.png" },
        { name: "Fitness", img: "https://rukminim2.flixcart.com/image/128/128/xif0q/gym-glove/x/s/c/-original-imahf4r9f9gzshge.jpeg?q=70" },
        { name: "Camping", img: "https://rukminim2.flixcart.com/image/128/128/xif0q/tent/g/l/z/-original-imahf4r9f9gzshge.jpeg?q=70" },
        { name: "Kids' cycles", img: "https://rukminim2.flixcart.com/image/128/128/xif0q/cycle/j/e/z/-original-imahf4r9f9gzshge.jpeg?q=70" },
        { name: "Cricket", img: "/images/products/cricket_set.png" }
    ];

    return (
        <div style={{ backgroundColor: '#f1f2f4', minHeight: '100vh', paddingTop: '128px' }}>
            <Header />

            <div style={{ maxWidth: '1440px', margin: '0 auto', padding: '12px 16px' }}>

                {/* 1. Sub-Category Navigation (rounded squares) */}
                <div style={{ backgroundColor: 'white', padding: '16px', borderRadius: '0', marginBottom: '16px', boxShadow: '0 1px 2px rgba(0,0,0,0.06)' }}>
                    <div style={{ display: 'flex', gap: '24px', overflowX: 'auto', paddingBottom: '8px', justifyContent: 'flex-start' }} className="no-scrollbar">
                        {subCategories.map((cat, i) => (
                            <div key={i} style={{ minWidth: '100px', cursor: 'pointer', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div
                                    style={{
                                        backgroundColor: '#e8f5e9',
                                        padding: '8px',
                                        borderRadius: '12px',
                                        border: '2px solid transparent',
                                        transition: '0.3s'
                                    }}
                                >
                                    <img src={cat.img} alt={cat.name} style={{ width: '70px', height: '70px', objectFit: 'contain' }} />
                                </div>
                                <p style={{ fontSize: '12px', fontWeight: '700', marginTop: '8px', margin: '8px 0 0 0' }}>{cat.name}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 2. Primary Hero Banner */}
                <div style={{ marginBottom: '24px', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
                    <Banner images={banners} height="320px" />
                </div>

                {/* 3. Summery Deals for You (Green Section) */}
                <div style={{ marginBottom: '32px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                        <h2 style={{ fontSize: '22px', fontWeight: '800', margin: 0 }}>Summery deals for you</h2>
                        <div style={{ width: '32px', height: '32px', backgroundColor: 'var(--color-primary)', color: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>&gt;</span>
                        </div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '16px' }}>
                        {[
                            { name: "Skating", off: "Min. 60% Off", img: "https://rukminim2.flixcart.com/image/312/312/xif0q/skate/s/k/n/-original-imahf4r9f9gzshge.jpeg?q=70" },
                            { name: "Cycling", off: "Min. 50% Off", img: "https://rukminim2.flixcart.com/image/312/312/xif0q/cycle/j/e/z/-original-imahf4r9f9gzshge.jpeg?q=70" },
                            { name: "Cardio", off: "Up to 70% Off", img: "/images/categories/sports/treadmill.png" },
                            { name: "Cricket", off: "Min. 50% Off", img: "/images/products/cricket_set.png" },
                            { name: "Badminton", off: "Min. 40% Off", img: "/images/categories/sports/badminton.png" }
                        ].map((item, i) => (
                            <div
                                key={i}
                                style={{
                                    backgroundColor: '#e8f5e9',
                                    padding: '16px',
                                    borderRadius: '20px',
                                    textAlign: 'start',
                                    position: 'relative',
                                    cursor: 'pointer',
                                    transition: '0.3s'
                                }}
                            >
                                <div style={{ backgroundColor: 'var(--color-primary)', color: 'white', position: 'absolute', top: '0', left: '50%', transform: 'translateX(-50%) translateY(-50%)', padding: '4px 12px', borderRadius: '8px', fontSize: '12px', fontWeight: '800', zIndex: 2 }}>
                                    {item.name}
                                </div>
                                <p style={{ fontWeight: '900', marginTop: '16px', color: '#1b5e20', fontSize: '16px', margin: '16px 0 0 0' }}>{item.off}</p>
                                <img src={item.img} alt={item.name} style={{ width: '150px', height: '150px', margin: '8px auto 0 auto', objectFit: 'contain', display: 'block' }} />
                            </div>
                        ))}
                    </div>
                </div>

                {/* 4. Restock on a discount (Green Section) */}
                <div style={{ marginBottom: '32px', backgroundColor: 'var(--color-primary)', padding: '24px', borderRadius: '20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', color: 'white' }}>
                        <h2 style={{ fontSize: '22px', fontWeight: '800', margin: 0 }}>Restock on a discount</h2>
                        <div style={{ display: 'flex', gap: '8px', cursor: 'pointer', alignItems: 'center' }}>
                            <span style={{ fontWeight: '700' }}>View All</span>
                            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>&gt;</span>
                        </div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '12px' }}>
                        {[
                            { tag: "Min. 60% Off", label: "Adult cycles", img: "https://rukminim2.flixcart.com/image/312/312/xif0q/cycle/j/e/z/-original-imahf4r9f9gzshge.jpeg?q=70" },
                            { tag: "Min. 70% Off", label: "Kids' cycles", img: "https://rukminim2.flixcart.com/image/312/312/xif0q/cycle/j/e/z/-original-imahf4r9f9gzshge.jpeg?q=70" },
                            { tag: "Min. 50% Off", label: "Treadmills", img: "/images/categories/sports/treadmill.png" },
                            { tag: "Min. 60% Off", label: "Cricket", img: "/images/products/cricket_set.png" },
                            { tag: "From ₹99", label: "Yoga", img: "/images/categories/sports/yoga.png" },
                            { tag: "Min. 50% Off", label: "Skating", img: "https://rukminim2.flixcart.com/image/312/312/xif0q/skate/s/k/n/-original-imahf4r9f9gzshge.jpeg?q=70" }
                        ].map((item, i) => (
                            <div key={i} style={{ backgroundColor: 'white', borderRadius: '12px', overflow: 'hidden', textAlign: 'start' }}>
                                <div style={{ padding: '16px' }}>
                                    <img src={item.img} alt={item.label} style={{ width: '100px', height: '100px', margin: '0 auto', objectFit: 'contain', display: 'block' }} />
                                </div>
                                <div style={{ backgroundColor: '#e8f5e9', padding: '4px 0', textAlign: 'center' }}>
                                    <p style={{ color: 'var(--color-primary)', fontWeight: '800', fontSize: '13px', margin: 0 }}>{item.tag}</p>
                                </div>
                                <div style={{ padding: '8px', textAlign: 'center' }}>
                                    <p style={{ fontSize: '13px', fontWeight: '700', color: '#444', margin: 0 }}>{item.label}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 5. Save on top brands (Brands Slider style) */}
                <div style={{ marginBottom: '40px' }}>
                    <h2 style={{ fontSize: '22px', marginBottom: '24px', fontWeight: '800' }}>Save on top brands</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '16px' }}>
                        {[
                            { name: "Urban Terrain", off: "Min. 50% Off", logo: "URBAN TERRAIN", img: "/images/categories/sports/cycle.png" },
                            { name: "PowerMax", off: "Up to 70% Off", logo: "PowerMax", img: "/images/categories/sports/treadmill.png" },
                            { name: "Lifelong", off: "Min. 50% Off", logo: "Lifelong", img: "https://rukminim2.flixcart.com/image/312/312/xif0q/exercise-bike/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
                            { name: "Nivea", off: "From ₹199", logo: "NIVEA", img: "https://rukminim2.flixcart.com/image/312/312/xif0q/sport-ball/s/c/n/-original-imahf4r9f9gzshge.jpeg?q=70" },
                            { name: "Leader", off: "Min. 50% Off", logo: "LEADER", img: "https://rukminim2.flixcart.com/image/312/312/xif0q/cycle/j/e/z/-original-imahf4r9f9gzshge.jpeg?q=70" }
                        ].map((brand, i) => (
                            <div
                                key={i}
                                style={{
                                    backgroundColor: '#f1f8e9',
                                    padding: '20px',
                                    borderRadius: '24px',
                                    border: '1px solid #dcedc8',
                                    textAlign: 'start',
                                    cursor: 'pointer',
                                    transition: '0.3s'
                                }}
                            >
                                <div style={{ backgroundColor: 'white', padding: '8px', borderRadius: '12px', marginBottom: '12px', border: '1px solid #ddd', textAlign: 'center' }}>
                                    <p style={{ fontWeight: '900', fontSize: '16px', color: '#333', margin: 0 }}>{brand.logo}</p>
                                </div>
                                <p style={{ fontWeight: '900', fontSize: '16px', color: '#333', marginBottom: '4px', margin: '0 0 4px 0' }}>{brand.off}</p>
                                <img src={brand.img} alt={brand.name} style={{ width: '140px', height: '140px', margin: '16px auto 0 auto', objectFit: 'contain', display: 'block' }} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Sports;

